<div class="mat-dialog-container">
  <div class="mat-dialog-header">
    <div class="mat-dialog-title">
      Import Students
    </div>
    <fa-icon (click)="dialogRef.close()" [icon]="['fas', 'close']"></fa-icon>
  </div>
  <div mat-dialog-content>
    <div class="help-text" >
      <fa-icon icon="info-circle"></fa-icon>
      <span class="General-Information">
        Upload CSV. Ensure the first column contains Student IDs, and include a header.
      </span>
    </div>
    <app-file-upload [allowedExtensions]="allowedFileExtensions" [maxMBFileSize]="100" (fileChanged)="handleFileChanged($event)">
    </app-file-upload>
    <button
      class="outline-button header-action-button standard-button upload-button"
      mat-button
      (click)="uploadFile()"
      type="button"
      [disabled]="!this.file"
    >
      Import students
    </button>
  </div>
</div>
